import { Text as ChakraText } from '@chakra-ui/react';
import {
  CSSTextAlign,
  PolymorphicProps,
  ResponsiveValue,
  StyleProps,
  SystemProps
} from './primitives.types';

export interface TextProps extends
  SystemProps,
  PolymorphicProps,
  Omit<React.ComponentPropsWithoutRef<'p'>, keyof StyleProps> {
  align?: ResponsiveValue<CSSTextAlign>;
  noOfLines?: number;
  isTruncated?: boolean;
  sx?: Record<string, unknown>;
}

export function Text(props: TextProps) {
  return <ChakraText {...props} />;
}